import PaidTierMenu from "./PaidTierMenu";

export default PaidTierMenu;
